import styled from "styled-components";
import { BaseButton } from "@shared/styles/common.styled";

export const CenterProductViewContainer = styled.section`
  max-width: "1532px";
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: white;
  padding-bottom: 30px;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  padding: 1.375rem;
  padding-left: 2rem;
  padding-right: 2rem;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.5) 14.95%,
    rgba(0, 76, 127, 0.1) 100%
  );
`;

export const SectionContainer = styled.section`
  width: 100%;
`;

export const FlexRow = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  > div {
    margin-right: 1rem;
  }
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr"};
  gap: 1.25rem;
  margin-bottom: ${(props) => props.marginBottom ?? "10px"};
  font-weight: normal;
  margin-top: ${(props) => props.marginTop ?? "10px"};
`;

export const BreadCrumb = styled.h2`
  color: #767676;
  font-size: 12px;
  font-family: lato;
  text-transform: initial;
  margin-bottom: 10px;
  line-height: 1;
  margin-top: 3px;
  font-weight: bold !important;
`;

export const ActionButtonDiv = styled.div`
  text-align: right;
`;

export const ProductTitle = styled.div`
  justify-self: auto;
  color: #0a4986;
  font-weight: bold !important;
`;

export const ButtonWrapper = styled.div`
  justify-self: end;
`;
export const ButtonData = styled(BaseButton)`
  background: ${(props) => (props?.color ? props.color : "#15aee5")};
  border: ${(props) =>
    props?.color ? "1px solid" + props.color : "1px solid #15aee5"};
  margin-right: ${(props) => (props?.marginRight ? props.marginRight : "0px")};
  font-weight: normal;
  width: auto;
  padding: 3px 10px;
  font-size: 14px;
  font-family: lato;
`;

export const CategoryDetail = styled.h2`
  color: #004c7f;
  font-size: 12px;
  font-family: lato;
  font-style: italic;
  text-transform: initial;
  margin-bottom: 10px;
  line-height: 1;
  margin-top: 3px;
  font-weight: bold !important;
`;
export const GenrealInfo = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 30px;
  box-shadow: 2px 2px 4px 1px rgba(0, 76, 127, 0.25);
  background-color: white;
  padding-bottom: 30px;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  .table-container {
    padding: 0 30px;
  }
`;
